<p-card [header]="controller.baseI18 + 'mfa' | translate" styleClass="h-full">
	<div class="space-y-3 flex flex-col">
		<div
			*ngIf="controller.hasNoMfaEnabled$ | async"
			[innerHTML]="controller.baseI18 + 'mfa-description' | translate"
		></div>
		<p-progressSpinner
			*ngIf="controller.isUpdatingMfa$ | async; else mfa"
			[style]="{ width: '30px', height: '30px' }"
		></p-progressSpinner>
		<ng-template #mfa>
			<button
				*ngIf="controller.hasMfaEnabled$ | async; else noMfa"
				[label]="controller.baseI18 + 'disable-mfa.label' | translate"
				(click)="onDisableMfaClick()"
				pButton
			></button>
			<ng-template #noMfa>
				<button
					[label]="controller.baseI18 + 'enable-mfa.label' | translate"
					(click)="onEnableMfaClick()"
					pButton
				></button>
			</ng-template>
		</ng-template>
	</div>
</p-card>
